/**
 * Formats a number with fixed decimal places (using toFixed)
 */
export function formatDecimal(
  value: number | string,
  decimals: number = 6
): string {
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  return numValue.toFixed(decimals);
}
